export const nursingHelpers = {
  getBMICategory: (bmi: number): string => {
    if (bmi < 18.5) return 'Berat Badan Kurang';
    if (bmi >= 18.5 && bmi < 23) return 'Normal';
    if (bmi >= 23 && bmi < 25) return 'Kelebihan Berat Badan';
    if (bmi >= 25 && bmi < 30) return 'Obesitas I';
    if (bmi >= 30) return 'Obesitas II';
    return 'Unknown';
  },

  calculateBMI: (height: number, weight: number): number => {
    const heightInMeters = height / 100;
    return Math.round((weight / (heightInMeters * heightInMeters)) * 100) / 100;
  },

  getBloodPressureCategory: (systolic: number, diastolic: number): string => {
    if (systolic >= 160 || diastolic >= 100) return 'Hipertensi Derajat 2';
    if (systolic >= 140 || diastolic >= 90) return 'Hipertensi Derajat 1';
    if (systolic >= 120 || diastolic >= 80) return 'Prehipertensi';
    if (systolic < 120 && diastolic < 80) return 'Normal';
    return 'Unknown';
  },

  isVitalSignAbnormal: (type: string, value: number): boolean => {
    switch (type) {
      case 'temperature': return value < 36.1 || value > 37.2;
      case 'pulse': return value < 60 || value > 100;
      case 'respiratory': return value < 12 || value > 20;
      case 'systolic_bp': return value < 90 || value > 140;
      case 'diastolic_bp': return value < 60 || value > 90;
      default: return false;
    }
  },
};
